export default [{
        path: '/dataList/paperSetMeal',
        component: resolve => require(['../pageManage.vue'], resolve),
        meta: {
            title: '套餐名称管理',
            authLogin: true
        }
    },
    {
        path: '/dataList/paperSet',
        component: resolve => require(['../page.vue'], resolve),
        meta: {
            title: '套餐顾客管理',
            authLogin: true
        }
    },
    // {
    //     path: '/data/paperCard/edit',
    //     component: resolve => require(['../edit.vue'], resolve),
    //     meta: {
    //         title: '新增纸质套餐',
    //         authLogin: true
    //     }
    // },
    // {
    //     path: '/data/paperCard/detail/:id',
    //     component: resolve => require(['../detail.vue'], resolve),
    //     meta: {
    //         title: '消费详情',
    //         authLogin: true
    //     }
    // },
]